import { render, staticRenderFns } from "./role-create-modal.vue?vue&type=template&id=cdf2c554&"
import script from "./role-create-modal.vue?vue&type=script&lang=js&"
export * from "./role-create-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports